/**
 * @generated SignedSource<<69bac72707bcc896770c2f554baf40e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WeekendVisibility_company$data = {
  readonly weekendDisplayPerUser: boolean | null;
  readonly weekendDisplayShowAlways: boolean | null;
  readonly createdAt: string | null;
  readonly " $fragmentType": "WeekendVisibility_company";
};
export type WeekendVisibility_company$key = {
  readonly " $data"?: WeekendVisibility_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"WeekendVisibility_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WeekendVisibility_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekendDisplayPerUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "weekendDisplayShowAlways",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "58cbddeadcc93ca828e3924985d6f159";

export default node;
